import { FormControl, FormLabel, Grid, Slider, Typography, TextField, IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';
import { useEffect, useState } from 'react';

const Edad = () => {
    const { promptData, setPromptData } = useActividadesContext();
     const [edad, setEdad] = useState(promptData.edad || 4);
       
         useEffect(() => {
           setPromptData((prevData) => ({
             ...prevData,
             edad: edad,
           }));
         }, [edad, setPromptData]);
       
         const handleSliderChange = (event, newValue) => {
           setEdad(newValue);
         };
       
         const handleInputChange = (event) => {
           const newValue = event.target.value === '' ? '' : Number(event.target.value);
           setEdad(newValue);
         };
       
         const handleIncrement = () => {
           setEdad((prev) => Math.min(prev + 1, 99));
         };
       
         const handleDecrement = () => {
           setEdad((prev) => Math.max(prev - 1, 4));
         };

    return (
        <Grid sx={{ mb: 3 }}>
            <FormControl component="fieldset">
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    Edad *
                </Typography>
                <FormLabel component="p" sx={{ fontFamily: 'montserrat', fontSize: '0.85rem', mt: 0.2 }}>
                    Selecciona la edad promedio de los estudiantes que participaran de la actividad
                </FormLabel>
                <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                    {/* Slider en la parte izquierda */}
                    <Grid item xs={8}>
                        <Slider
                            value={typeof edad === 'number' ? edad : 0}
                            onChange={handleSliderChange}
                            step={1}
                            min={4}
                            max={99}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${value} años`}
                            aria-labelledby="edad-slider"
                            sx={{
                                color: '#336B87',
                                '& .MuiSlider-markLabel': {
                                    color: '#336B87',
                                    fontFamily: 'montserrat',
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: '#F9DA96',
                                    color: '#209099',
                                    fontFamily: 'montserrat'
                                },
                            }}
                        />
                    </Grid>
                    {/* Contador en la parte derecha */}
                    <Grid item xs={4} container spacing={1}>
                        <Grid item>
                            <IconButton onClick={handleDecrement} disabled={edad <= 4}>
                                <Remove />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <TextField
                                variant="standard"
                                value={edad}
                                onChange={handleInputChange}
                                inputProps={{
                                    step: 1,
                                    min: 4,
                                    max: 99,
                                    type: 'text',
                                    fontFamily: 'montserrat',
                                    color: '#336B87',
                                    sx: { fontFamily: 'montserrat', color: '#336B87', textAlign: 'center' }
                                }}
                                sx={{ width: 40, textAlign: 'center', fontFamily: 'montserrat', color: '#336B87' }}
                            />
                        </Grid>

                        <Grid item>
                            <IconButton onClick={handleIncrement} disabled={edad >= 99}>
                                <Add />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </FormControl>
        </Grid>
    );
};

export default Edad;